"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionType = void 0;
var QuestionType;
(function (QuestionType) {
    QuestionType["EDUCATIONAL_LEVEL"] = "study_level";
    QuestionType["INSTITUTE_OF_ORIGIN"] = "institute_of_origin";
    QuestionType["FIELD_OF_STUDY"] = "disciplines";
    QuestionType["DISCIPLINE_INTERESTS"] = "discipline_interests";
    QuestionType["COUNTRY_INTERESTS"] = "country_interests";
    QuestionType["START_PERIOD"] = "start_period";
    QuestionType["GPA"] = "gpa";
    QuestionType["WORK_EXPERIENCE"] = "work_experience";
    QuestionType["ENGLISH_SKILLS"] = "englishproficiency";
    QuestionType["TUITION_BUDGET"] = "tuition_budget";
    QuestionType["LIVING_BUDGET"] = "living_budget";
    QuestionType["NATIONALITY"] = "nationality_country_id";
    QuestionType["COUNTRY_OF_RESIDENCE"] = "residence_country_id";
    QuestionType["EMAIL"] = "email";
    QuestionType["TELEPHONE"] = "telephone";
    QuestionType["BIRTH_DATE"] = "birth_date";
    QuestionType["SAVE_PROGRESS"] = "create_account";
    QuestionType["FIND_BACHELORS"] = "academic_highschool";
    QuestionType["INTRODUCTION"] = "introduction";
    QuestionType["GENDER"] = "gender";
    QuestionType["NAME"] = "name";
    QuestionType["ATTENDANCE"] = "attendance";
    QuestionType["EMAIL_PREFERENCES"] = "email_preferences";
    QuestionType["CURRENCY"] = "currency";
    QuestionType["UNIVERSITY_APPLICATION"] = "university_application";
})(QuestionType || (exports.QuestionType = QuestionType = {}));
